import { useState, useCallback } from 'react';
import { getSearchHistory, addSearchHistory, clearSearchHistory } from '../lib/search-history';
import type { SearchHistoryEntry } from '../lib/search-history';

export function useSearchHistory() {
  const [history, setHistory] = useState<SearchHistoryEntry[]>(getSearchHistory);

  const add = useCallback((entry: Omit<SearchHistoryEntry, 'timestamp'>) => {
    addSearchHistory(entry);
    setHistory(getSearchHistory());
  }, []);

  const clear = useCallback(() => {
    clearSearchHistory();
    setHistory([]);
  }, []);

  const refresh = useCallback(() => {
    setHistory(getSearchHistory());
  }, []);

  return { history, add, clear, refresh };
}
